export default function FeatureStrip() {
  return (
    <div className="feature-strip" data-testid="feature-strip">
      <div className="feature-item">Takes only a few minutes</div>
      <div className="feature-item">Easy &amp; simple journey</div>
      <div className="feature-item">We find your paperwork</div>
      <div className="feature-item">100% No Win No Fee**</div>
    </div>
  );
}
